export default "__VITE_ASSET__CGOuLPXV__"